import { Styles } from 'react-modal'
import theme from 'theme_'
import { Close as CloseIcon } from 'components/Icons'
import {
  StyledModalContent,
  StyledModalInner,
  ModalHeaderContainer,
  ModalContentContainer,
  ModalCloseBtn,
} from './styles'
import { ModalProps } from './types'

// Content styling in styles.ts; Overlay styling here
export const customModalStyles: Styles = {
  content: {},
  overlay: {
    zIndex: theme.zIndex.modal,
    backgroundColor: theme.overlay.modalCommon,
    backdropFilter: theme.overlay.SBlur,
    WebkitBackdropFilter: theme.overlay.SBlur,
  },
}

function BaseModal(props: ModalProps) {
  return (
    <StyledModalContent
      ariaHideApp={false}
      style={customModalStyles}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      {...props}
    >
      <StyledModalInner>
        <ModalHeaderContainer>
          <ModalCloseBtn onClick={props.onRequestClose}>
            <CloseIcon />
          </ModalCloseBtn>
        </ModalHeaderContainer>
        <ModalContentContainer>{props.children}</ModalContentContainer>
      </StyledModalInner>
    </StyledModalContent>
  )
}

export default BaseModal
